import React from 'react'
import PropTypes from 'prop-types'

import {
  WorkflowRunSteps
} from '../components'


export default class Workflow extends React.Component {
  static propTypes = {
    match: PropTypes.shape({
      params: PropTypes.shape({
        workflowRunUUID: PropTypes.string.isRequired
      })
    }).isRequired
  }

  render() {
    return (
      <WorkflowRunSteps
        workflowRunId={this.props.match.params.workflowRunUUID}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/Workflow.js